import { Capacitor } from '@capacitor/core';

export const isNativeApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch (e) {
    return false;
  }
};

export const isIOSDevice = () => {
  const ua = navigator.userAgent || '';
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

/**
 * Hand a finished file to the device and report what actually happened:
 * 'shared' (iPhone share sheet completed), 'cancelled', or 'downloaded' (browser download).
 * On iPhone the share sheet is used because it offers Save to Files plainly; if iOS refuses it
 * (the tap is no longer fresh), the ordinary download is used instead of failing.
 */
export const deliverDownload = async (blob, filename, mime) => {
  const file = new File([blob], filename, { type: mime });
  if (isIOSDevice() && navigator.share && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return 'shared';
    } catch (e) {
      if (e?.name === 'AbortError') return 'cancelled';
      if (e?.name !== 'NotAllowedError') throw e;
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoking at once cancels the download in Safari; keep the file alive long enough to be saved.
  setTimeout(() => URL.revokeObjectURL(url), 30000);
  return 'downloaded';
};
